"use client";
import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "../config/axios";

export default function LoginPage() {
  const authContext = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    setError(null);
    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.post("/auth/login", { email, password });
      if (response.status === 200) {
        if (response.data?.token) localStorage.setItem("authToken", response.data.token);
        if (response.data?.user && authContext) authContext.setUser(response.data.user);
        // Hard navigation so AuthProvider and storeConfig re-init cleanly.
        window.location.href = "/shop";
      }
    } catch (err: any) {
      console.error("Login failed:", err);
      setError(err.response?.data?.error || "Login error — please check your credentials.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen flex items-start justify-center py-12 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-1">Sign in</h2>
          <p className="text-sm text-gray-500 mb-6">Access your wholesale account.</p>

          <form onSubmit={handleLogin} className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700 mb-1">Email</label>
              <input
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">Password</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="p-3 rounded bg-red-50 border border-red-200 text-sm text-red-700">{error}</div>
            )}

            <button
              type="submit"
              disabled={submitting}
              className={`w-full py-2.5 rounded-lg font-semibold text-white transition ${
                submitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="mt-6 text-sm text-gray-600 text-center">
            Don&apos;t have an account?{" "}
            <a href="/shop/register" className="text-blue-600 hover:text-blue-700 font-medium">
              Apply for wholesale
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
